import { defineComponent as _defineComponent } from 'vue'
import ButtonCommon from "../buttons/ButtonCommon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationDialog',
  props: {
    body: { default: "" },
    icon: { default: "$icon_delete" },
    iconColor: { default: "positive" },
    showing: { type: Boolean, default: true },
    showProgress: { type: Boolean, default: false },
    title: null
  },
  setup(__props: any) {




return { __sfc: true,ButtonCommon }
}

})